import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {Routes} from 'navigation/Routes';
import {ProjectStatusScreen} from './ProjectStatus';
import {ProjectRequirements} from './ProjectRequirements';
import {ProjectManagementNavigation} from './ProjectManagement';
import {ProjectTeamManagement} from './ProjectTeamManagement';
const ProjectDashboardStack = createNativeStackNavigator();
import {
  ScreenWithLayout,
  ProjectDashbordLayout,
} from 'components/common/screen-layouts';

export function ProjectDashboardScreens() {
  return (
    <ProjectDashboardStack.Navigator screenOptions={{headerShown: false}}>
      {/* project status */}
      <ProjectDashboardStack.Screen name={Routes.PROJECT_STATUS}>
        {props => (
          <ScreenWithLayout {...props}>
            <ProjectDashbordLayout {...props}>
              <ProjectStatusScreen {...props} />
            </ProjectDashbordLayout>
          </ScreenWithLayout>
        )}
      </ProjectDashboardStack.Screen>

      {/* project requirement */}
      <ProjectDashboardStack.Screen name={Routes.PROJECT_REQUIREMENT}>
        {props => (
          <ScreenWithLayout {...props}>
            <ProjectDashbordLayout {...props}>
              <ProjectRequirements {...props} />
            </ProjectDashbordLayout>
          </ScreenWithLayout>
        )}
      </ProjectDashboardStack.Screen>

      {/* project requirement */}
      <ProjectDashboardStack.Screen name={Routes.TEAM_MANAGEMENT}>
        {props => (
          <ScreenWithLayout {...props}>
            <ProjectDashbordLayout {...props}>
              <ProjectTeamManagement {...props} />
            </ProjectDashbordLayout>
          </ScreenWithLayout>
        )}
      </ProjectDashboardStack.Screen>

      <ProjectDashboardStack.Screen name={Routes.PROJECT_MANAGEMENT}>
        {props => (
          <ScreenWithLayout {...props}>
            <ProjectDashbordLayout {...props}>
              <ProjectManagementNavigation {...props}/>
            </ProjectDashbordLayout>
          </ScreenWithLayout>
        )}
      </ProjectDashboardStack.Screen>
    </ProjectDashboardStack.Navigator>
  );
}
